import { FC } from "react";
import styled from "styled-components";

const Small = styled.small<{ $isSelected: boolean }>`
	font-size: ${({ theme }) => theme.fonts.sizes.small};
	color: ${({ theme, $isSelected }) => ($isSelected ? theme.colors.dropdown.active : theme.colors.palette.grey[70])};
`;

const SelectDefaultOption = styled.span<{ $isSelected: boolean }>`
	${({ theme, $isSelected }) => ($isSelected ? `color: ${theme.colors.dropdown.active}` : "")};
`;

export const UserSelectOption: FC<{
	user: { name: string; email: string };
	isSelected: boolean;
}> = ({ user: { name, email }, isSelected }) => {
	return (
		<SelectDefaultOption $isSelected={isSelected}>
			<div>{name}</div>
			<Small $isSelected={isSelected}>{email}</Small>
		</SelectDefaultOption>
	);
};
